import React from "react";

// Use relative path so the logo loads from whichever domain serves the app
// (works on preview, production, and custom domains alike without rebuild).
const LOGO_DARK = "/api/static/brand/logo_transparent.png";
const LOGO_WHITE = "/api/static/brand/logo_white.png";

export const Logo = ({ size = "md", className = "", invert = false }) => {
  const heights = { sm: 26, md: 38, lg: 54, xl: 76 };
  const h = heights[size] || heights.md;
  return (
    <img
      src={invert ? LOGO_WHITE : LOGO_DARK}
      alt="SİNE81 Haber | TV"
      style={{ height: h, width: "auto" }}
      className={`select-none ${className}`}
      draggable={false}
    />
  );
};

export const LogoMark = ({ size = 32 }) => (
  <img src={LOGO_DARK} alt="SİNE81" style={{ height: size, width: "auto" }} className="select-none" draggable={false} />
);
